import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import {
  ListItem,
  Section,
  Container,
  SectionTitle,
} from 'chaoskit/src/components'

import Data from '~components/Data'
import Image from '~components/Image'
import PlusDecorationList from '~components/PlusDecorationList'

export const UseCases = ({ heading, blurb, useCases, getIcon }) => {
  const theme = useTheme()

  return (
    <Section space="xlarge">
      <Container>
        <SectionTitle as="h2" title={heading} sub={blurb} />
        <div
          css={{
            display: 'grid',
            gap: theme.space.large,

            [theme.mq.medium]: {
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: theme.space.xlarge,
              marginTop: theme.space.xlarge * 2,
            },
          }}
        >
          {useCases.map((useCase) => (
            <UseCase key={useCase.heading} data={useCase} getIcon={getIcon} />
          ))}
        </div>
      </Container>
    </Section>
  )
}

UseCases.propTypes = {
  blurb: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  useCases: PropTypes.array.isRequired,
  getIcon: PropTypes.func.isRequired,
}

const UseCase = ({ data, getIcon }) => {
  const theme = useTheme()

  return (
    <div>
      <div
        css={{
          display: 'grid',
          gridTemplateColumns: `${theme.height.large}px 1fr`,
          gap: theme.space.base,
          alignItems: 'center',
        }}
      >
        <Image src={getIcon(data.icon)} />
        <h3 css={{ margin: 0 }}>
          <Data>{data.heading}</Data>
        </h3>
        <div
          css={{
            gridColumn: '1 / span 2',

            [theme.mq.medium]: {
              gridColumn: 2,
            },
          }}
        >
          <PlusDecorationList>
            {data.examples.map((item) => (
              <ListItem key={item.blurb}>
                <Data>{item.blurb}</Data>
              </ListItem>
            ))}
          </PlusDecorationList>
        </div>
      </div>
    </div>
  )
}

UseCase.propTypes = {
  data: PropTypes.object.isRequired,
  getIcon: PropTypes.func.isRequired,
}
